<template>
  <div style="min-height: 100vh;" class="footerFix"><!--class="app"-->
    <NavBar></NavBar>
    <Sidebar></Sidebar>
    <router-view/>
    <Footer></Footer>

    <!-- <chatModal ref="ModalChat"></chatModal> -->
  </div>
  
</template>

<script>
import NavBar from '../components/menu/Navbar';
import Sidebar from '../components/menu/Sidebar';
import Footer from '../components/Footer';

  export default {
    name: "DashboardLayout",
    components: {
      NavBar, 
      Sidebar,
      Footer
    },
    data() {
        return {}
    },
    methods: {
    },
    mounted() {
    },
    created() {
    },
  }
</script>

<style scoped>
.footerFix {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/DashboardLayout.vue